const mapViewSelectors = function() {
  const selectors = {};

  const getDisplayType = function(type) {
    const display = {
      client: 'public',
      global: 'global',
      user: 'private',
    };

    return display[type];
  };

  const getType = function(entity) {
    if (entity.clientId) {
      if (entity.userId) {
        return 'user';
      }
      if (entity.editable) {
        return 'client';
      }
      return 'global';
    }
  };

  const getLists = function(state) {
    return state.mapViews.idsByOwner;
  };

  const getListByType = function(state, type) {
    if (getLists(state).hasOwnProperty(type)) {
      return getLists(state)[type];
    }

    return null;
  };

  const getEntities = function(state) {
    return state.mapViews.byId;
  };


  selectors.getMapView = function(state, id) {
    const mapView = getEntities(state)[id];

    if (!mapView) return null;

    return Object.assign({}, mapView, {
      type: getDisplayType(getType(mapView)),
    });
  };

  selectors.getMapViewsByType = function(state, type) {
    if (typeof (type) !== 'string') {
      console.error('Type must be a string'); /* eslint no-console: 0 */
      return null;
    }

    const list = getListByType(state, type);

    if (list) {
      return list.reduce((acc, curr) => {
        const mapView = selectors.getMapView(state, curr);

        acc.push(mapView);

        return acc;
      }, []);
    }

    return [];
  };


  selectors.getMapViewsByTypes = function(state, types) {
    return types.reduce((acc, curr) => acc.concat(selectors.getMapViewsByType(state, curr)), []);
  };

  return selectors;
};

export default mapViewSelectors();
